export const IPS = [
  '1.222.94.83',
  '27.122.242.72',
  '27.122.242.76',
  '27.122.242.78',
  '27.122.242.79',
  '27.122.242.81',
  '27.122.242.84',
  '112.219.71.44',
  '112.219.71.45',
  '115.114.17.62',
  '116.120.157.41',
  '116.120.157.52',
  '121.66.144.138',
  '121.66.144.140',
  '121.66.144.141',
  '121.66.144.142',
  ...Array.from({ length: 255 }, (_, i) => `182.224.177.${i + 1}`),
  '195.160.253.7',
  '203.247.149.152',
  '203.247.149.205',
  '203.247.149.239',
  '203.247.149.242',
  '203.247.149.244',
  '217.79.6.41',
  '217.79.6.42',
  '217.79.6.43',
  '217.79.6.44',
  '217.79.6.45',
  '217.79.6.46',
  '222.112.209.235',
  ...Array.from({ length: 255 }, (_, i) => `49.172.166.${i + 1}`),
  '57.128.33.199',
  '51.222.139.96',
  '139.99.170.132',
]
